
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/meemo",
      function () {
        return require("private-next-pages/cases/meemo/index.tsx");
      }
    ]);
  